import {
  Outlet,
  createFileRoute,
  notFound,
  redirect,
} from '@tanstack/react-router'
import z from 'zod/v4'
import { getBookingQueryOptions } from '@/queries/query'
import { isHttpError } from '@/utils/http'

export const Route = createFileRoute('/my-booking/$id')({
  params: {
    parse: (params) => ({
      id: z.string().trim().parse(params.id),
    }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => {
    try {
      return await context.queryClient.ensureQueryData(
        getBookingQueryOptions(params.id),
      )
    } catch (error) {
      if (isHttpError(error, 401)) {
        if (!context.authContext.isAuthenticated)
          throw redirect({
            to: '/auth/login',
          })
        throw notFound()
      }
      if (isHttpError(error, 404)) {
        throw notFound()
      }
      throw error
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
